import React from 'react';
import { motion } from 'framer-motion';
import { PackageOpen, CheckCircle2 } from 'lucide-react';
const topics = [{
  emoji: '🦺',
  label: 'Uso de EPP'
}, {
  emoji: '🪜',
  label: 'Trabajo en Altura'
}, {
  emoji: '⚡',
  label: 'Riesgo Eléctrico'
}, {
  emoji: '🔥',
  label: 'Prevención de Incendios'
}, {
  emoji: '🩹',
  label: 'Primeros Auxilios'
}, {
  emoji: '🚪',
  label: 'Evacuación'
}, {
  emoji: '🧍',
  label: 'Ergonomía'
}, {
  emoji: '📦',
  label: 'Manipulación de Cargas'
}, {
  emoji: '☣️',
  label: 'Sustancias Químicas'
}, {
  emoji: '🕳️',
  label: 'Espacios Confinados'
}, {
  emoji: '🧹',
  label: 'Orden y Limpieza'
}, {
  emoji: '❤️‍🩹',
  label: 'Salud Ocupacional'
}, {
  emoji: '➕',
  label: 'Y muchos más...'
}];
const sectors = [{
  emoji: '🏗️',
  label: 'Construcción'
}, {
  emoji: '🏭',
  label: 'Industria'
}, {
  emoji: '🚚',
  label: 'Logística'
}, {
  emoji: '🏢',
  label: 'Oficinas'
}, {
  emoji: '🏥',
  label: 'Hospitales'
}, {
  emoji: '🛎️',
  label: 'Servicios'
}];
const included = ['📝 Guion del Capacitador', '📊 Presentación lista para utilizar', '✍️ Evaluación de conocimientos', '🗒️ Registro de asistencia', '🏅 Certificado de participación'];
export function ModulesSection() {
  return <section className="py-16 md:py-24 bg-transparent" data-id="element-116">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-117">
        <div className="text-center mb-10" data-id="element-118">
          <span className="inline-flex items-center gap-2 px-6 py-2.5 mb-5 rounded-full border border-white/40 bg-[#4A553F] text-white font-semibold tracking-[0.18em] uppercase text-xs" data-id="element-119">
            <PackageOpen className="w-4 h-4 text-[#d4a017]" data-id="element-120" />
            ¿Qué contiene?
          </span>
          <h2 className="font-heading font-bold text-[#2f3a2c] text-3xl md:text-5xl leading-tight mb-4" data-id="element-121">
            ¿QUÉ CONTIENE EL{' '}
            <span className="italic text-[#5C6851]" data-id="element-122">SISTEMA MAESTRO?</span>
          </h2>
          <p className="text-lg md:text-xl font-bold text-[#5C6851] max-w-2xl mx-auto" data-id="element-123">
            Todo lo que necesitás para brindar capacitaciones profesionales
            durante todo el año. 💪
          </p>
        </div>

        {/* Intro card */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-white/60 border border-amber-100 rounded-3xl p-7 md:p-9 shadow-sm mb-8 text-center" data-id="element-124">
          <p className="text-slate-700 text-[15px] md:text-lg leading-relaxed" data-id="element-125">
            📚 El{' '}
            <span className="font-bold text-[#5C6851]" data-id="element-126">
              Sistema Maestro de Capacitaciones HyS
            </span>{' '}
            reúne más de{' '}
            <span className="font-bold text-[#2f3a2c]" data-id="element-127">150 páginas</span> con el
            método completo para{' '}
            <span className="font-semibold text-[#2f3a2c]" data-id="element-128">planificar</span>,{' '}
            <span className="font-semibold text-[#2f3a2c]" data-id="element-129">dictar</span> y{' '}
            <span className="font-semibold text-[#2f3a2c]" data-id="element-130">documentar</span>{' '}
            capacitaciones de forma profesional.
          </p>
        </motion.div>

        {/* Topics grid */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="mb-10" data-id="element-131">
          <h3 className="font-heading font-bold text-[#2f3a2c] text-xl md:text-2xl mb-5 text-center" data-id="element-132">
            🎯 Incluye los temas más importantes de Higiene y Seguridad
          </h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3" data-id="element-133">
            {topics.map((t, i) => <motion.div key={i} initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.04
          }} className="flex items-center gap-2.5 bg-white border border-slate-200 rounded-xl px-4 py-3 shadow-sm" data-id="element-134">
                <span className="text-xl flex-shrink-0" aria-hidden="true" data-id="element-135">
                  {t.emoji}
                </span>
                <span className="font-semibold text-[#2f3a2c] text-sm md:text-[15px] leading-tight" data-id="element-136">
                  {t.label}
                </span>
              </motion.div>)}
          </div>
        </motion.div>

        {/* Sectors */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-[#4A553F] rounded-3xl p-7 md:p-9 shadow-sm mb-10 text-center" data-id="element-137">
          <h3 className="font-heading font-bold text-white text-xl md:text-2xl mb-5" data-id="element-138">
            🏢 Adaptado a los rubros que más lo necesitan
          </h3>
          <div className="flex flex-wrap justify-center gap-3 mb-6" data-id="element-139">
            {sectors.map((s, i) => <span key={i} className="inline-flex items-center gap-2 bg-white/10 border border-white/20 text-white rounded-full px-4 py-2 text-sm font-semibold" data-id="element-140">
                <span aria-hidden="true" data-id="element-141">{s.emoji}</span>
                {s.label}
              </span>)}
          </div>
          <p className="text-[#e6ddc7] text-sm md:text-base leading-relaxed max-w-2xl mx-auto" data-id="element-142">
            ⚖️ Con una guía práctica basada en la{' '}
            <span className="font-bold text-white" data-id="element-143">Ley 19.587</span>, el{' '}
            <span className="font-bold text-white" data-id="element-144">Decreto 351</span> y la
            normativa <span className="font-bold text-white" data-id="element-145">SRT</span> vigente.
          </p>
        </motion.div>

        {/* Each training includes */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-white border border-amber-100 rounded-3xl p-7 md:p-9 shadow-lg shadow-black/5" data-id="element-146">
          <h3 className="font-heading font-bold text-[#2f3a2c] text-2xl md:text-3xl mb-6 text-center" data-id="element-147">
            ✨ Cada capacitación incluye:
          </h3>
          <div className="grid sm:grid-cols-2 gap-3 max-w-2xl mx-auto" data-id="element-148">
            {included.map((item, i) => <div key={i} className="flex items-center gap-3 bg-emerald-50 border border-emerald-100 rounded-xl px-4 py-3" data-id="element-149">
                <CheckCircle2 className="w-5 h-5 text-emerald-500 flex-shrink-0" aria-hidden="true" data-id="element-150" />
                <span className="font-semibold text-[#2f3a2c] text-[15px] leading-tight" data-id="element-151">
                  {item}
                </span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}